// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:errors` (see frontend/package.json).
// Source: agent.shared.types.repository.MergeRequiredError

import { RpcError, registerRpcError } from "@/app_store/rpc_error";

// Wire shape of this error: `code` discriminates the type, `message` is the
// human-readable text, and the remaining keys are the exception's own fields.
export interface MergeRequiredErrorData {
    code: "MergeRequiredError";
    message: string;
    behind: number;
}

export class MergeRequiredError extends RpcError {
    readonly code = "MergeRequiredError" as const;
    readonly behind: number;

    constructor(data: MergeRequiredErrorData) {
        super(data.code, data.message, data);
        this.behind = data.behind;
    }
}

registerRpcError("MergeRequiredError", MergeRequiredError);
